import React, { useState } from "react"
import EditBirthdate from '../../../components/EditBirthdate'
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { QuestionProps } from '../../../typings/register';
import { RootState } from "../../../redux/store";
import { updateMemberBirthday } from '../../../services/memberService'
import QuestionUpdateHeader from "./QuestionUpdateHeader";
import { GenderType } from "../../../helpers/Enums";

const UpdateBirthdate = () => {
    const [question, setQuestion] = useState<QuestionProps>();
    const member = useSelector((state: RootState) => state.member);
    let history = useHistory();

    const onSave = async (value: string) => {
        await updateMemberBirthday(member.memberCode, value);
        //history.goBack();
    };

    return (
        <>
            <QuestionUpdateHeader />

            <EditBirthdate
                buttonText={"שמור"}
                subtitle={member.genderId === GenderType.MALE ? "הקהילה שלנו מיועדת לבני 60+ . בהמשך תתבקש לאמת את גילך כחלק מאימות הפרופיל" : "הקהילה שלנו מיועדת לבני 60+ . בהמשך תתבקשי לאמת את גילך כחלק מאימות הפרופיל"}
                title={"מתי נולדת"}
                value2={member.dateOfBirth}
                value={undefined}
                onSave={onSave}
            />
        </>
    )
}

export default UpdateBirthdate


